import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { replace } from 'connected-react-router';
import { Button } from '@dealersocket/ds-ui-react/Button';
import {
  Typography,
  TypographyVariants,
} from '@dealersocket/ds-ui-react/Typography';
import * as AlertStore from '../../store/Alert';
import * as CommonStore from '../../store/CommonForm';
import { Page } from '../../shared/components/Page';
import { continueLogin } from '../../shared/utils/continue-login';

type CreatePasswordSuccessProps = {
  replace: any;
} & typeof AlertStore.actionCreators &
  typeof CommonStore.actionCreators;

const CreatePasswordSuccess = (props: CreatePasswordSuccessProps) => {
  const continueToApplication = () => {
    continueLogin(
      props.setIsSubmitting,
      props.replace,
      props.setAlertMessage,
      props.clearAlertMessage
    );
  };

  return (
    <Page>
      <Typography variant={TypographyVariants.H5} paragraph>
        PASSWORD CREATED
      </Typography>
      <Typography variant={TypographyVariants.Body1} paragraph>
        You have successfully created your password. You will use this new
        password going forward.
      </Typography>
      <Button
        data-e2e="continueButton"
        color="primary"
        onClick={continueToApplication}
      >
        Continue
      </Button>
    </Page>
  );
};

function mapStateToProps(state) {
  return { ...state.commonForm.dataModel };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { replace, ...AlertStore.actionCreators, ...CommonStore.actionCreators },
    dispatch
  );
}

export const CreatePasswordSuccessPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(CreatePasswordSuccess);
